import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, ArrowRight } from 'lucide-react';

const EmptyCart = () => {
  const sections = [
    {
      title: "National Articles",
      route: "/section/national-articles",
      color: "#10b981",
      desc: "Local wholesale goods & staples"
    },
    {
      title: "Premium & Imported",
      route: "/section/premium-imported",
      color: "#3b82f6",
      desc: "Top-tier international brands"
    },
    {
      title: "Accessories",
      route: "/section/accessories",
      color: "#8b5cf6",
      desc: "Bespoke hardware, leather, & jewelry"
    },
    {
      title: "Fragrance & Grooming",
      route: "/section/fragrance-grooming",
      color: "#f97316",
      desc: "Luxury scents & personal care"
    }
  ];

  return (
    <div className="empty-cart-container">
      <div className="empty-cart-card">
        <div className="empty-cart-icon-wrapper">
          <ShoppingCart size={48} className="empty-cart-icon" />
          <div className="empty-cart-icon-glow" />
        </div>
        
        <h2 className="empty-cart-title">Your Cart is Empty</h2>
        <p className="empty-cart-subtitle">
          Review requirements, group orders by section, and unlock wholesale pricing.
        </p>

        <div className="empty-sections-header">
          <span>Shop by Section</span>
        </div>

        <div className="empty-sections-grid">
          {sections.map((sec) => (
            <Link 
              key={sec.route} 
              to={sec.route} 
              className="empty-section-chip"
              style={{ '--section-theme': sec.color }}
            >
              <div className="empty-chip-content">
                <span className="empty-chip-title">{sec.title}</span>
                <span className="empty-chip-desc">{sec.desc}</span>
              </div>
              <ArrowRight size={16} className="empty-chip-arrow" />
            </Link>
          ))}
        </div>

        <Link to="/shop" className="btn btn-primary empty-shop-btn">
          Explore All Products
        </Link>
      </div>
    </div>
  );
};

export default EmptyCart;
